exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".personalinfo-box{margin:0 -15px}.personalinfo-box .district-box,.personalinfo-box .zipcode-box{width:25%}@media screen and (max-width:640px){.personalinfo-box .district-box,.personalinfo-box .zipcode-box{width:50%}.personalinfo-box .zipcode-box{padding-right:2%}.personalinfo-box .district-box{padding-left:2%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./js-src/markdown-editor/modules/personalinfo/personalinfo.styl
// module id = 16
// module chunks = 0 1